module.exports = __webpack_public_path__ + "static/media/bonusCardButton.4282b8fd.png";